import type { Persona } from './types';

// Growth's naming convention, the same in Ads Manager for every campaign:
//   campaign  FB Ads - [program] - OBJ:Leads
//   ad set    [program] - Lead Gen - [persona]
//   ad        [program]_[persona]_[creative]

export type NamingObjective = 'leads' | 'traffic';

const OBJECTIVE_SUFFIX: Record<NamingObjective, string> = { leads: 'OBJ:Leads', traffic: 'OBJ:Traffic' };
const AD_SET_TYPE: Record<NamingObjective, string> = { leads: 'Lead Gen', traffic: 'Traffic' };

export const campaignName = (program: string, objective: NamingObjective) => `FB Ads - ${program.trim()} - ${OBJECTIVE_SUFFIX[objective]}`;

/** Several personas read "Sales + RevOps" in the ad set name and "Sales+RevOps" in an ad name. */
export function adSetName(program: string, objective: NamingObjective, personas: readonly Persona[]): string {
  return [program.trim(), AD_SET_TYPE[objective], personas.join(' + ')].filter(Boolean).join(' - ');
}

/** Without a program and a persona, the ad keeps the creative's own name. */
export function adName(program: string, personas: readonly Persona[], creative: string): string {
  return program.trim() && personas.length > 0 ? `${program.trim()}_${personas.join('+')}_${creative.trim()}` : creative.trim();
}
